import { render, staticRenderFns } from "./user_detail.vue?vue&type=template&id=12e2cdc4&scoped=true&"
import script from "./user_detail.vue?vue&type=script&lang=js&"
export * from "./user_detail.vue?vue&type=script&lang=js&"
import style0 from "./user_detail.vue?vue&type=style&index=0&id=12e2cdc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2cdc4",
  null
  
)

export default component.exports